import React from 'react';
import { Button } from 'antd';
import styles from './gradientButton.module.scss';

export const GradientButton = (props) => {
  const {
    children,
    htmlType = 'button',
    onClick,
    disabled = false,
    loading = false,
    className = '',
    style = {},
    variant = 'filled',
    icon,
  } = props;

  const variantClass = variant === 'outline' ? styles.outlineButton : styles.gradientButton;

  return (
    <Button
      type="primary"
      htmlType={htmlType}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      className={`${variantClass} ${className}`}
      style={style}
      icon={icon}
    >
      {children}
    </Button>
  );
};
